import { render, staticRenderFns } from "./addcourse.vue?vue&type=template&id=5d23216a&scoped=true"
import script from "./addcourse.vue?vue&type=script&lang=js"
export * from "./addcourse.vue?vue&type=script&lang=js"
import style0 from "./addcourse.vue?vue&type=style&index=0&id=5d23216a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23216a",
  null
  
)

export default component.exports